export const formatBytes = (bytes: number, decimals = 2) => {
  const baseUnit = 'B';

  if (bytes === 0) return `0 ${baseUnit}`;

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = [baseUnit, 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};
